import ComplementoIntereses from './ComplementoIntereses';
import ComplementoDividendos from './ComplementoDividendos';
import ComplementoPlanesderetiro from './ComplementoPlanesderetiro';
import ComplementoPagosaextranjeros from './ComplementoPagosaextranjeros';
import ComplementoEnajenaciondeAcciones from './ComplementoEnajenaciondeAcciones';
import ComplementoInteresesHipotecarios from './ComplementoInteresesHipotecarios';
import ComplementoOperacionesconderivados from './ComplementoOperacionesconderivados';
import ComplementoPlataformasTecnologicas from './ComplementoPlataformasTecnologicas';
import ComplementoFideicomisoNoEmpresarial from './ComplementoFideicomisoNoEmpresarial';
import ComplementoArrendamientoenfideicomiso from './ComplementoArrendamientoenfideicomiso';

const complementosList = {
  Arrendamientoenfideicomiso: ComplementoArrendamientoenfideicomiso,
  Dividendos: ComplementoDividendos,
  EnajenaciondeAcciones: ComplementoEnajenaciondeAcciones,
  Intereses: ComplementoIntereses,
  Intereseshipotecarios: ComplementoInteresesHipotecarios,
  Operacionesconderivados: ComplementoOperacionesconderivados,
  Pagosaextranjeros: ComplementoPagosaextranjeros,
  Planesderetiro: ComplementoPlanesderetiro,
  ServiciosPlataformasTecnologicas: ComplementoPlataformasTecnologicas,
  Fideicomisonoempresarial: ComplementoFideicomisoNoEmpresarial,
};

export default complementosList;
